<iframe
  *ngIf="!!appConfig.helpLink"
  [src]="appConfig.helpLink | safeUrl"
  [appBlockModalDrag]="!(isMobileModeObservable | async)"
></iframe>
